import { render, staticRenderFns } from "./review-item.vue?vue&type=template&id=3769486c&scoped=true&"
import script from "./review-item.vue?vue&type=script&lang=js&"
export * from "./review-item.vue?vue&type=script&lang=js&"
import style0 from "./review-item.vue?vue&type=style&index=0&id=3769486c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769486c",
  null
  
)

export default component.exports